// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1-4Op","col":"CardReaderDesc_col__2cKKw","label":"CardReaderDesc_label__31zmS"};